<template>
  <div class="app">
    <AppHeader fixed>
      <p class="logo d-none d-lg-block">VIỆT TỘC</p>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="ml-auto">
        <DefaultHeaderDropdownSetting />
      </b-navbar-nav>
    </AppHeader>

    <div class="app-body">
      <AppSidebar fixed>
        <SidebarNav class="sidebar_nav" :navItems="nav"></SidebarNav>

        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import MethodService from "@/service/MethodService";
import nav from "@/_nav";
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb,
} from "@coreui/vue";
import DefaultAside from "./DefaultAside";
import DefaultHeaderDropdownSetting from "./DefaultHeaderDropdownSetting";
import LanguageService from "../service/LanguageService";
import mushroom from "viettoc-api";
import eventBus from "../service/EventBus";
export default {
  name: "DefaultContainer",
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownSetting,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
  },
  data() {
    return {
      aLang: LanguageService.lang,
      nav: MethodService.copyObject(nav.items),
      // currentUser: MethodService.getCurrentUser(),
      // navNew: [],
      // prevUrl: null,
    };
  },

  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        (route) => route.name || route.meta.label
      );
    },
  },
  methods: {
    async fn_countBanIn() {
      if (
        JSON.parse(localStorage.getItem("currentUser")).roles.indexOf(
          "SystemAdmin"
        ) == 0 ||
        JSON.parse(localStorage.getItem("currentUser")).roles.indexOf(
          "SalesManager"
        ) == 0 ||
        JSON.parse(localStorage.getItem("currentUser")).roles.indexOf(
          "InGiaPhaSales"
        ) == 0 ||
        JSON.parse(localStorage.getItem("currentUser")).roles.indexOf(
          "CustomerCareUser"
        ) == 0
      ) {
        try {
          let response = await mushroom.ban_in.listAsync(
            {
              filters: ["trang_thai=gui_yeu_cau"],
              limit: 1,
            },
            { enabledCache: false }
          );
          $.each(this.nav, (index, item) => {
            if (item.code == "BanIn") {
              item.badge.text = response.meta.total;
            }
          });
        } catch (error) {
          if (error.code === 4) {
            window.toastr.error(this.aLang.no_server);
          } else if (error.code === 2) {
            window.toastr.error("Gặp sự cố tải dữ liệu");
          } else {
            window.toastr.error("Đã có lỗi xảy ra");
          }
        }
      }
    },
    async fn_countLoiNhan() {
      if (
        JSON.parse(localStorage.getItem("currentUser")).roles.indexOf(
          "SystemAdmin"
        ) == 0 ||
        JSON.parse(localStorage.getItem("currentUser")).roles.indexOf(
          "ContentAdmin"
        ) == 0
      ) {
        try {
          let response = await mushroom.ldp_loi_nhan.listAsync(
            {
              fields:
                "id,ho_ten,dien_thoai,email,noi_dung,loai_loi_nhan,trang_thai,file_dinh_kem,thoi_diem_tao,thoi_diem_cap_nhat,nguoi_cap_nhat_id",
              filters: ["trang_thai:in:moi,dang_xu_ly"],
              limit: 1,
            },
            { enabledCache: false }
          );
          $.each(this.nav, (index, item) => {
            if (item.code == "LoiNhan") {
              item.badge.text = response.meta.total;
            }
          });
        } catch (error) {
          console.log(error);
          if (error.code === 4) {
            window.toastr.error(this.aLang.no_server);
          } else if (error.code === 2) {
            window.toastr.error("Gặp sự cố tải dữ liệu");
          } else {
            window.toastr.error("Đã có lỗi xảy ra");
          }
        }
      }
    },

    async fn_countDanhGia() {
      try {
        let response = await mushroom.ldp_danh_gia.listAsync();
        $.each(this.nav, (index, item) => {
          if (item.code == "DanhGia") {
            item.badge.text = response.meta.total;
          }
        });
      } catch (error) {
        console.log(error);
        if (error.code === 4) {
          window.toastr.error(this.aLang.no_server);
        } else if (error.code === 2) {
          window.toastr.error("Gặp sự cố tải dữ liệu");
        } else {
          window.toastr.error("Đã có lỗi xảy ra");
        }
      }
    },
    async fn_countDangKyDongHo() {
      if (
        JSON.parse(localStorage.getItem("currentUser")).roles.indexOf(
          "SystemAdmin"
        ) == 0 ||
        JSON.parse(localStorage.getItem("currentUser")).roles.indexOf(
          "CustomerCareUser"
        ) == 0
      ) {
        try {
          let response = await mushroom.dang_ky.listAsync(
            {
              filters: ["trang_thai:in:dang_cho,dang_xu_ly"],
              limit: 1,
            },
            { enabledCache: false }
          );
          $.each(this.nav, (index, item) => {
            if (item.code == "DangKyDongHo") {
              item.badge.text = response.meta.total;
            }
          });
        } catch (error) {
          if (error.code === 4) {
            window.toastr.error(this.aLang.no_server);
          } else if (error.code === 2) {
            window.toastr.error("Gặp sự cố tải dữ liệu");
          } else {
            window.toastr.error("Đã có lỗi xảy ra");
          }
        }
      }
    },

    async fn_getNav() {
      let currentUser = MethodService.getCurrentUser();

      let arrNav = MethodService.copyObject(nav.items);

      $.each(arrNav, (indexNar1, valueNarLever1) => {
        if (
          valueNarLever1.meta.allowAccess &&
          valueNarLever1.meta.allowAccess.length > 0
        ) {
          //check quyền truy cập Nav1
          $.each(
            valueNarLever1.meta.allowAccess,
            (indexMeta1, valueMetaLever1) => {
              if (
                currentUser.roles.indexOf(valueMetaLever1) != -1 ||
                valueMetaLever1 == "*"
              ) {
                valueNarLever1.meta.allow = true;
              }
            }
          );
          //check xem tồn tại Nav2
          if (valueNarLever1.children && valueNarLever1.children.length > 0) {
            $.each(valueNarLever1.children, (indexNar2, valueNarLever2) => {
              if (
                valueNarLever2.meta.allowAccess &&
                valueNarLever2.meta.allowAccess.length > 0
              ) {
                //check quyền truy cập Nav2
                $.each(
                  valueNarLever2.meta.allowAccess,
                  (indexMeta2, valueMetaLever2) => {
                    if (
                      currentUser.roles.indexOf(valueMetaLever2) != -1 ||
                      valueMetaLever2 == "*"
                    ) {
                      valueNarLever2.meta.allow = true;
                    }
                  }
                );
                //check xem tồn tại Nav3
                if (
                  valueNarLever2.children &&
                  valueNarLever2.children.length > 0
                ) {
                  $.each(
                    valueNarLever2.children,
                    (indexNar3, valueNarLever3) => {
                      if (
                        valueNarLever3.meta.allowAccess &&
                        valueNarLever3.meta.allowAccess.length > 0
                      ) {
                        //check quyền truy cập Nav3
                        $.each(
                          valueNarLever3.meta.allowAccess,
                          (indexMeta3, valueMetaLever3) => {
                            if (
                              currentUser.roles.indexOf(valueMetaLever3) !=
                                -1 ||
                              valueMetaLever3 == "*"
                            ) {
                              valueNarLever3.meta.allow = true;
                            }
                          }
                        );
                        //Mở rộng thêm ở đây
                      }
                    }
                  );
                }
              }
            });
          }
        }
      });
      //Check Lọc quyền Nav1 và trả về mảng đã lọc arrNavFilter
      let arrNavFilter = arrNav.filter(function (value, index, arr) {
        return value.meta.allow == true;
      });
      $.each(arrNavFilter, function (indexNavF1, valueNavF1) {
        //check tồn tại Nav2
        if (valueNavF1.children && valueNavF1.children.length > 0) {
          // Lọc quyền Nav2 và trả về mảng đã lọc arrNavFilter2
          let arrNavFilter2 = valueNavF1.children.filter(function (
            value2,
            index2,
            arr2
          ) {
            return value2.meta.allow == true;
          });
          //gán mảng Nav2 đã lọc vào mảng mẹ
          valueNavF1.children = arrNavFilter2;
          $.each(arrNavFilter2.children, function (indexNavF12, valueNavF2) {
            //check tồn tại Nav3
            if (valueNavF2.children && valueNavF2.children.length > 0) {
              // Lọc quyền Nav3 và trả về mảng đã lọc arrNavFilter3
              var arrNavFilter3 = valueNavF2.children.filter(function (
                value3,
                index3,
                arr3
              ) {
                return value3.meta.allow == true;
              });
              //gán mảng Nav3 đã lọc vào mảng mẹ
              valueNavF2.children = arrNavFilter3;
              // Mở rộng tiếp theo ở đây
            }
          });
        }
      });
      // Gán mảng mẹ vào Nav Main
      this.nav = arrNavFilter;
    },

    refreshData() {
      this.fn_countLoiNhan();
      this.fn_countDangKyDongHo();
      this.fn_countBanIn();
      setTimeout(async () => {
        await this.refreshData();
      }, 300000);
    },
  },
  async created() {
    this.fn_getNav();
    this.refreshData();
    eventBus.$off();
    eventBus.$on("goiLaiDemLoiNhan", () => {
      this.fn_countLoiNhan();
    });

    eventBus.$on("duyetDangKyDongHo", () => {
      this.fn_countDangKyDongHo();
    });

    eventBus.$on("doiTrangThaiBanIn", () => {
      this.fn_countBanIn();
    });
  },
  mouted() {},
  beforeUpdate(to, from, next) {},
};
</script>

<style scoped>
@font-face {
  font-family: "Noh Carborne";
  src: url("../fonts/TUV Noh Carbone.ttf");
}
body {
  background-color: #f7f9fa !important;
}
::v-deep .sidebar .nav-dropdown-toggle {
  position: relative;
}
::v-deep .sidebar .nav-dropdown-toggle::after {
  position: absolute;
  font-family: "Font Awesome 6 Pro";
  font-weight: 900;
  content: "\f0d9";

  top: 16%;
  right: 10px;
  font-size: 20px;
  color: #e0ab45;

  z-index: 1;
  transition: 0.3s;
}
::v-deep .sidebar .nav-dropdown.open > .nav-dropdown-toggle::after {
  transform: rotate(-90deg);
}
::v-deep .sidebar .nav-dropdown.open::before {
  background-color: transparent;
}
::v-deep .sidebar .nav-link:hover.nav-dropdown-toggle::before {
  background-image: none !important;
}

/* ::v-deep .sidebar .nav-link .badge {
  margin-top: 3px;
  padding: 5px;
  background-color: #9e1c1e;
} */
.logo {
  font-family: "Noh Carborne";
  background: -webkit-linear-gradient(
    #f9bc60 0%,
    #ffca78 20.31%,
    #fed9b7 53.12%,
    #fac96a 76.04%,
    #e0ab45 100%
  );
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 30px;
  padding: 0 49px;
  margin-bottom: 6px;
}
.sidebar {
  background-color: #2f353a !important;
}
.app-header {
  box-shadow: rgb(0 0 0 / 20%) 0px 5px 10px;
  background-color: #9e1c1e;
}
.header-fixed .app-body {
  margin-top: 55px;
}
.el-scrollbar__bar {
  opacity: 1 !important;
}
.activeClassRoute {
  color: #fff !important;
  background: #293846;
  border-bottom: 4px solid #19aa8d;
}
::v-deep .sidebar .nav-item,
::v-deep .sidebar .nav-link {
  position: relative;
  overflow: hidden;
}

::v-deep .sidebar .nav-item::before,
::v-deep .sidebar .nav-link::before {
  content: "";
  position: absolute;

  left: 0;
  width: 5px;
  height: 100%;
  background-color: #e0ab45;
  transform: translateY(-51%);
}
::v-deep .sidebar .nav-item::before {
  z-index: 3;
  top: -30px;
  transition: 0.3s;
  border-radius: 16px;
}
::v-deep .sidebar .nav-link::before {
  z-index: 2;
  top: -22px;
}
::v-deep .sidebar .nav-item:hover::before {
  top: 50%;
  height: 60%;
}
::v-deep .sidebar .nav-link.active::before {
  top: 22px;
}
::v-deep .sidebar .nav-dropdown.open .nav-link.active,
::v-deep .sidebar .nav-link.active {
  border-left: none;
}
.container-fluid {
  padding: 10px 10px 0px 10px;
  position: relative;
}
.animated {
  box-shadow: rgb(0 0 0 / 35%) 0px 5px 15px;
}
.d-md-down-none span {
  color: black;
}
::v-deep .app-header .navbar-toggler .navbar-toggler-icon {
  background-image: none;
  cursor: pointer;
  height: auto;
  transition: 0.3s;
  margin-left: 18px;
}
.navbar-toggler-icon::before:hover {
  color: #e0ab45;
}

::v-deep .sidebar {
  background-color: #3c4b64;
}
::v-deep .sidebar .nav-link:hover {
  background: #4e4e4e;
}
::v-deep .sidebar .nav-link.active {
  background: hsla(0, 0%, 100%, 0.05);
  /* border-left: none; */
}
::v-deep .sidebar .nav-link .nav-icon {
  font-size: 16px;
}
::v-deep .sidebar .nav-title {
  color: #fff;
  font-size: 100%;
}
@media (min-width: 992px) {
  .sidebar-fixed .app-header + .app-body .sidebar {
    height: calc(100vh - 55px);
  }
  .sidebar-minimized .sidebar .sidebar-minimizer {
    bottom: 0px !important;
  }
}
</style>
<style>
.main-body {
  padding: 15px 0;
}
</style>
